import { connect } from "react-redux";
import {
  receiveDatalistSearchPromisify,
  updateProspect,
  updateRoProspect
} from "../../../../../../store/actions/appConfig";
import { SignatoryBankingRelationshipsComponent } from "./SignatoryBankingRelationships";

const mapDispatchToProps = {
  updateProspect,
  updateRoProspect,
  getDatalistSearch: receiveDatalistSearchPromisify
};

export const SignatoryBankingRelationships = connect(
  null,
  mapDispatchToProps
)(SignatoryBankingRelationshipsComponent);
